var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrganizatioSuperadmin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30_165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.5875 28.2812C36.5875 29.6758 35.457 30.8063 34.0625 30.8063C32.668 30.8063 31.5375 29.6758 31.5375 28.2812C31.5375 26.8867 32.668 25.7563 34.0625 25.7563C35.457 25.7563 36.5875 26.8867 36.5875 28.2812Z",
    stroke: "black",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0625 34.3504C35.5132 34.3504 36.8457 33.8376 37.8898 32.9867C38.7671 33.737 39.3219 34.8509 39.3219 36.0941V38.8285C39.3219 39.1443 39.0658 39.4004 38.75 39.4004H28.8031V36.0941C28.8031 34.8509 29.3579 33.737 30.2352 32.9867C31.2793 33.8376 32.6118 34.3504 34.0625 34.3504Z",
    stroke: "black",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.525 28.2812C22.525 29.6758 21.3945 30.8063 20 30.8063C18.6055 30.8063 17.475 29.6758 17.475 28.2812C17.475 26.8867 18.6055 25.7563 20 25.7563C21.3945 25.7563 22.525 26.8867 22.525 28.2812Z",
    stroke: "black",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 34.3504C21.4507 34.3504 22.7832 33.8376 23.8273 32.9867C24.7046 33.737 25.2594 34.8509 25.2594 36.0941V39.4004H14.7406V36.0941C14.7406 34.8509 15.2954 33.737 16.1727 32.9867C17.2168 33.8376 18.5493 34.3504 20 34.3504Z",
    stroke: "black",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4625 28.2812C8.4625 29.6758 7.33202 30.8063 5.9375 30.8063C4.54298 30.8063 3.4125 29.6758 3.4125 28.2812C3.4125 26.8867 4.54298 25.7563 5.9375 25.7563C7.33202 25.7563 8.4625 26.8867 8.4625 28.2812Z",
    stroke: "black",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.9375 34.3504C7.38819 34.3504 8.72075 33.8376 9.76476 32.9867C10.6421 33.737 11.1969 34.8509 11.1969 36.0941V39.4004H1.25C0.934183 39.4004 0.678125 39.1443 0.678125 38.8285V36.0941C0.678125 34.8509 1.2329 33.737 2.11024 32.9867C3.15425 33.8376 4.48681 34.3504 5.9375 34.3504Z",
    stroke: "black",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.525 3.125C22.525 4.51952 21.3945 5.65 20 5.65C18.6055 5.65 17.475 4.51952 17.475 3.125C17.475 1.73048 18.6055 0.6 20 0.6C21.3945 0.6 22.525 1.73048 22.525 3.125Z",
    stroke: "black",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.10938 20.5723H6.50937V21.1723V22.2402C6.32126 22.2222 6.13052 22.2129 5.9375 22.2129C5.74448 22.2129 5.55374 22.2222 5.36563 22.2402V20.0004C5.36563 19.6846 5.62168 19.4285 5.9375 19.4285H18.8281H19.4281V18.8285V17.7879H20.5719V18.8285V19.4285H21.1719H34.0625C34.3783 19.4285 34.6344 19.6846 34.6344 20.0004V22.2402C34.4463 22.2222 34.2555 22.2129 34.0625 22.2129C33.8695 22.2129 33.6787 22.2222 33.4906 22.2402V21.1723V20.5723H32.8906H7.10938ZM25.2594 13.6723C25.2594 13.9881 25.0033 14.2441 24.6875 14.2441H15.3125C14.9967 14.2441 14.7406 13.9881 14.7406 13.6723V10.9379C14.7406 9.69462 15.2954 8.58077 16.1727 7.83042C17.2168 8.68138 18.5493 9.19414 20 9.19414C21.4507 9.19414 22.7832 8.68138 23.8273 7.83042C24.7046 8.58077 25.2594 9.69462 25.2594 10.9379V13.6723Z",
    stroke: "black",
    strokeWidth: 1.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30_165"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganizatioSuperadmin);
export default __webpack_public_path__ + "static/media/organizatio_superadmin.487e4a151809bc33649ea155d31d9199.svg";
export { ForwardRef as ReactComponent };